








































import { Component, Prop, Vue } from 'vue-property-decorator';

import axios from 'axios';
import { required } from 'vuelidate/lib/validators';

import { UserGroup } from '@/lib/models';

@Component({
  validations: {
    form: {
      name: {
        required,
      },
    },
  },
})
export default class CreateEditUserGroupModal extends Vue {
  @Prop({ required: true }) private readonly userGroup!: UserGroup;

  private form: any = {
    isNewUserGroup: this.userGroup === null,
    name: null,
    description: null,
  };

  private submitting: boolean = false;

  private onShow(): void {
    // Using $nextTick ensures that changes to the `userGroup` prop in the
    // parent component will have had time to propagate down to this component
    this.$nextTick(() => {
      if (this.userGroup === null) {
        this.resetForm();
      } else {
        this.prepopulateForm();
      }
    });
  }

  private resetForm(): void {
    this.form.isNewUserGroup = true;
    this.form.name = null;
    this.form.description = null;
    this.$v.form.$reset();
  }

  private prepopulateForm(): void {
    this.form.isNewUserGroup = false;
    this.form.name = this.userGroup.name;
    this.form.description = this.userGroup.description;
    this.$v.form.$touch();
  }

  private handleOk(bvModalEvent: Event): void {
    bvModalEvent.preventDefault();
    this.submitting = true;
    const userGroupData: UserGroup = {
      id: this.userGroup?.id,
      name: this.form.name,
      description: this.form.description,
    };
    if (this.form.isNewUserGroup) {
      this.createUserGroup(userGroupData);
    } else {
      this.updateUserGroup(userGroupData);
    }
  }

  private async createUserGroup(userGroup: UserGroup): Promise<void> {
    const url: string = `${process.env.VUE_APP_BACKEND_API_HOST}/usergroups`;
    const accessToken: string = await (this as any).$auth0.getAccessTokenSilently();
    axios.post(url, userGroup, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }).then((response) => {
      const message: string = `Successfully created user group: ${userGroup.name}`;
      this.$bvModal.msgBoxOk(message, {
        title: 'User Group Created',
        okVariant: 'success',
        centered: true,
      }).then(() => {
        this.$emit('create-user-group');
        this.$nextTick(() => {
          (this.$refs.modal as any).hide();
        });
      });
    }).catch((error) => {
      const message: string = error.response?.data?.message ?? error.message;
      this.$bvModal.msgBoxOk(message, {
        title: 'Error Creating User Group',
        okVariant: 'danger',
        centered: true,
      });
    }).finally(() => {
      this.submitting = false;
    });
  }

  private async updateUserGroup(userGroup: UserGroup): Promise<void> {
    const url: string = `${process.env.VUE_APP_BACKEND_API_HOST}/usergroups/${this.userGroup.id}`;
    const accessToken: string = await (this as any).$auth0.getAccessTokenSilently();
    axios.put(url, userGroup, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }).then((response) => {
      const message: string = `Successfully updated user group: ${userGroup.name}`;
      this.$bvModal.msgBoxOk(message, {
        title: 'User Group Updated',
        okVariant: 'success',
        centered: true,
      }).then(() => {
        this.$emit('update-user-group');
        this.$nextTick(() => {
          (this.$refs.modal as any).hide();
        });
      });
    }).catch((error) => {
      const message: string = error.response?.data?.message ?? error.message;
      this.$bvModal.msgBoxOk(message, {
        title: 'Error Updating User Group',
        okVariant: 'danger',
        centered: true,
      });
    }).finally(() => {
      this.submitting = false;
    });
  }
}
